import api from '../api';
import {toast} from "react-toastify";
import messageTypes from "../../constants/MessagesTypes";
import { addCompanyIdToRequest } from '../../utils/companyContext';

export async function getProducts(data) {
  const params = addCompanyIdToRequest(data || {}, 'GET');
  
  return api.get(`/api/product`, {
    params: params,
    headers: {
      'Content-Type': 'multipart/form-data',
      auth: true
    },
  }).catch((error) => {
    toast.error(messageTypes.ERROR_LOAD);
    return [];
  });
}

export function edit(id, data) {
  const dataWithCompany = addCompanyIdToRequest(data, 'POST');
  
  return api.post(`/api/product/edit/${id}`, dataWithCompany, {
    headers: {
      'Content-Type': 'application/json',
      auth: true
    },
  });
}

export function save(product) {
  const dataWithCompany = addCompanyIdToRequest(product, 'POST');
  
  return api.post('/api/product/new', dataWithCompany, {
    headers: {
      'Content-Type': 'application/json',
      auth: true
    },
  });
}

export async function getProduct(id) {
  try {
    const params = addCompanyIdToRequest({}, 'GET');

    const response = await api.get(`/api/product/${id}/find`, {
      params: params,
      headers: {
        'Content-Type': 'multipart/form-data',
        auth: true
      },
    });

    return response.data.data ? response.data.data : {};

  } catch (err) {
    toast.error(messageTypes.ERROR_LOAD);
    throw err;
  }
}

export async function deleteProduct(id) {
  // Para DELETE, usamos query params
  const params = addCompanyIdToRequest({}, 'DELETE');
  
  return api.delete(`/api/product/delete/${id}`, {
    params: params,
    headers: {
      'Content-Type': 'application/json',
      auth: true
    },
  });
}
